import React from "react";
import { LoadableRenderer } from "web/src/components/markdown/LoadableRenderer";
import { CodeBlock } from "web/src/components/markdown/CodeBlock";
import { InlineCode } from "web/src/components/markdown/Typography";
import { MarkdownComponents } from "../markdown-components/MarkdownComponents";

export const DocsMarkdownRenderer = (props: { markdown: string; markdownComponentsOverride?: any }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { code = "", ...rest } = { ...MarkdownComponents, ...props.markdownComponentsOverride };

  return (
    <LoadableRenderer
      markdown={props.markdown}
      markdownComponents={{
        code(props: { [x: string]: any; children: any; className: any }) {
          const { children, className } = props;
          const match = /language-(\w+)/.exec(className || "");

          // CodeBlock markdown components were originally intended to be used with MDX, so this is a little bit of a hack to get them to work with react-markdown
          return match ? <CodeBlock language={match[1]}>{String(children)}</CodeBlock> : <InlineCode>{children}</InlineCode>;
        },

        ...rest,
      }}
    />
  );
};
